import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=53f3b510&scoped=true"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseSelect.vue?vue&type=style&index=0&id=53f3b510&prod&lang=scss&scoped=true"
import style1 from "./BaseSelect.vue?vue&type=style&index=1&id=53f3b510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f3b510",
  null
  
)

export default component.exports